module.exports = __webpack_public_path__ + "img/brgr-logo-white.7aaddd6e.svg";